import { employeeServiceApi } from "../../apis/employeeService.api";
import { EMPLOYEE_API_TAGS } from "../../app.constants";
import type {
  ICreateEmployeeDto,
  IEmployee,
  IGenericResponse,
  IUpdateEmployeeDto,
} from "./employee.types";

export const employeeApi = employeeServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    createEmployee: builder.mutation<IGenericResponse, ICreateEmployeeDto>({
      query: (body) => ({
        url: "/employees",
        method: "POST",
        body,
      }),
      invalidatesTags: [EMPLOYEE_API_TAGS.EMPLOYEE],
    }),

    getEmployees: builder.query<IEmployee[], void>({
      query: () => ({
        url: "/employees",
        method: "GET",
      }),
      providesTags: [EMPLOYEE_API_TAGS.EMPLOYEE],
    }),

    getEmployeeMe: builder.query<IEmployee, void>({
      query: () => ({
        url: "/employees/me",
        method: "GET",
      }),
      providesTags: [EMPLOYEE_API_TAGS.EMPLOYEE],
    }),

    getEmployee: builder.query<IEmployee, number>({
      query: (id) => ({
        url: `/employees/${id}`,
        method: "GET",
      }),
      transformResponse: (response: { data: IEmployee }) => {
        return response.data;
      },
      providesTags: [EMPLOYEE_API_TAGS.EMPLOYEE],
    }),

    updateEmployee: builder.mutation<
      IGenericResponse,
      { id: number; data: IUpdateEmployeeDto }
    >({
      query: ({ id, data }) => ({
        url: `/employees/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [EMPLOYEE_API_TAGS.EMPLOYEE],
    }),

    deleteEmployee: builder.mutation<IGenericResponse, number>({
      query: (id) => ({
        url: `/employees/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [EMPLOYEE_API_TAGS.EMPLOYEE],
    }),
  }),
});

export const {
  useCreateEmployeeMutation,
  useGetEmployeesQuery,
  useGetEmployeeMeQuery,
  useGetEmployeeQuery,
  useUpdateEmployeeMutation,
  useDeleteEmployeeMutation,
} = employeeApi;
